module.exports = __webpack_public_path__ + "static/media/DKS-26_02.c2e174a6.jpg";